import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            Everyone is selling AI. We make it real.
          </h1>
          <p className="hero-subtitle">
            We don't sell software. We don't sell advice. We sell the thing that sits between them. A forward-deployed team that maps how your business actually runs, then builds the software that closes the gap between owning AI and using it.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;

